import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import { ValidationService } from '../../services/validation-service'
import { RegistrationActions } from '../../actions/registration-actions'
import { CustomerActions } from '../../actions/customer-actions'
import { customerGetters } from '../../stores/customer-store'
import { infoToast, successToast } from '../../toaster'
import { userGetters } from '../../stores/user-store'
import { AnalyticsActions } from '../../actions/analytics-actions'
import { Title } from '@angular/platform-browser'
import { Customer } from '../../types'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'
import { environment } from '../../environments/environment'
import { FeatureQueries, Feature } from '../../graphql/queries/feature.queries'

@Component({
  selector: 'nc-registration-page',
  template: `
    <div class="left-nav-layout customer-signup">
      <div class="content-wrapper">
        <div class="left-nav">
          <nc-nav></nc-nav>
        </div>
        <div id="detail-content" class="detail-content">
          <div class="inner-detail-content mt-5">
            <div class="container-fluid">
              <div class="row mt-3">
                <div class="col-md-10 offset-md-1">
                  <div class="registration-buttons">
                    <div
                      class="registration-button"
                      [class.active]="classification == 'agency'"
                      (click)="updateClassification('agency')">
                      <div class="subtitle">I'm an</div>
                      <h5 class="title">Agency</h5>
                      <div class="subtitle">I need content for my clients</div>
                    </div>
                    <div
                      class="registration-button"
                      [class.active]="classification == 'business'"
                      (click)="updateClassification('business')">
                      <div class="subtitle">I'm a</div>
                      <h5 class="title">Business</h5>
                      <div class="subtitle">I need content for myself</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-10 offset-md-1 mt-3">
                  <p>
                    Or, <a href="/d/users/sign_up/writer" class="nc-txt-link">I'm a writer</a> who
                    wants to provide content for Verblio
                  </p>
                </div>
                <div class="col-md-10 offset-md-1">
                  <ng-template [ngIf]="classification">
                    <ng-template [ngIf]="classification !== 'writer'">
                      <h1>Sign in as your {{ classification }}</h1>
                    </ng-template>
                    <ng-template [ngIf]="classification === 'writer' && writerWaitlistEnabled()">
                      <h1>Applications Closed</h1>
                      <p>
                        We are not currently accepting new writer applications. Please enter your
                        information and we'll contact you when our application process is reopened
                        (approx. 3-5 months). Thanks for your interest in becoming a Verblio writer!
                      </p>
                    </ng-template>
                    <form
                      *ngIf="classification == 'business'"
                      [formGroup]="businessForm"
                      (ngSubmit)="onSubmit(businessForm)">
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="customer">
                            <label for="business-name">Business Name</label>
                            <input
                              id="business-name"
                              class="form-control"
                              formControlName="businessName"
                              placeholder="Business name" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                businessForm.controls.customer.controls.businessName.valid ||
                                (businessForm.controls.customer.controls.businessName.pristine &&
                                  !businessSubmitted) ||
                                (businessForm.controls.customer.controls.businessName.untouched &&
                                  !businessSubmitted)
                              ">
                              You must enter a business name
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="email">Email</label>
                            <input
                              id="email"
                              class="form-control"
                              formControlName="email"
                              placeholder="email@example.com" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                businessForm.controls.user.controls.email.valid ||
                                (businessForm.controls.user.controls.email.pristine &&
                                  !businessSubmitted) ||
                                (businessForm.controls.user.controls.email.untouched &&
                                  !businessSubmitted)
                              ">
                              Email invalid
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12" formGroupName="user">
                          <fieldset class="form-group">
                            <label for="pass"
                              >Create Password
                              <span class="small text-muted">(at least 8 characters)</span></label
                            >
                            <input
                              type="password"
                              id="pass"
                              class="form-control"
                              formControlName="password"
                              placeholder="password" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                businessForm.controls.user.controls.password.valid ||
                                (businessForm.controls.user.controls.password.pristine &&
                                  !businessSubmitted) ||
                                (businessForm.controls.user.controls.password.untouched &&
                                  !businessSubmitted)
                              ">
                              Password invalid
                            </div>
                            <ul class="mt-3 mb-1">
                              <li>At least 8 characters</li>
                              <li>At least 1 uppercase character</li>
                              <li>At least 1 lowercase character</li>
                              <li>At least 1 number</li>
                            </ul>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row bottom-buffer">
                        <div class="col-md-6 col-sm-10 col-12">
                          <div class="text-right float-right">
                            <button
                              type="submit"
                              class="btn-lg hot-orange-button small-bottom-buffer block"
                              [disabled]="saving">
                              Sign Up
                            </button>
                            <div>or <a href="/d/users/sign_in">sign in</a></div>
                          </div>
                        </div>
                      </div>
                    </form>

                    <form
                      *ngIf="classification == 'agency'"
                      [formGroup]="agencyForm"
                      (ngSubmit)="onSubmit(agencyForm)">
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="account">
                            <label for="agency-name">Agency Name</label>
                            <input
                              id="agency-name"
                              class="form-control"
                              formControlName="accountName"
                              placeholder="Agency name" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                agencyForm.controls.account.controls.accountName.valid ||
                                (agencyForm.controls.account.controls.accountName.pristine &&
                                  !agencySubmitted) ||
                                (agencyForm.controls.account.controls.accountName.untouched &&
                                  !agencySubmitted)
                              ">
                              You must enter the name of your agency
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="email">Email</label>
                            <input
                              id="email"
                              class="form-control"
                              formControlName="email"
                              placeholder="email@example.com" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                agencyForm.controls.user.controls.email.valid ||
                                (agencyForm.controls.user.controls.email.pristine &&
                                  !agencySubmitted) ||
                                (agencyForm.controls.user.controls.email.untouched &&
                                  !agencySubmitted)
                              ">
                              Email invalid
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="pass"
                              >Create Password
                              <span class="small text-muted">(at least 8 characters)</span></label
                            >
                            <input
                              type="password"
                              id="pass"
                              class="form-control"
                              formControlName="password"
                              placeholder="password" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                agencyForm.controls.user.controls.password.valid ||
                                (agencyForm.controls.user.controls.password.pristine &&
                                  !agencySubmitted) ||
                                (agencyForm.controls.user.controls.password.untouched &&
                                  !agencySubmitted)
                              ">
                              Password invalid
                            </div>
                            <ul class="mt-3 mb-1">
                              <li>At least 8 characters</li>
                              <li>At least 1 uppercase character</li>
                              <li>At least 1 lowercase character</li>
                              <li>At least 1 number</li>
                            </ul>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row bottom-buffer">
                        <div class="col-md-6 col-sm-10 col-12">
                          <div class="text-right float-right">
                            <button
                              type="submit"
                              class="btn-lg hot-orange-button small-bottom-buffer block"
                              [disabled]="saving">
                              Sign Up
                            </button>
                            <div>or <a href="/d/users/sign_in">sign in</a></div>
                          </div>
                        </div>
                      </div>
                    </form>

                    <form
                      *ngIf="classification == 'writer'"
                      [formGroup]="writerForm"
                      (ngSubmit)="onSubmit(writerForm)">
                      <div class="row">
                        <div class="col-md-4 col-sm-5 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="first-name">First Name</label>
                            <input
                              id="first-name"
                              class="form-control"
                              formControlName="firstName"
                              placeholder="First" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                writerForm.controls.user.controls.firstName.valid ||
                                (writerForm.controls.user.controls.firstName.pristine &&
                                  !writerSubmitted) ||
                                (writerForm.controls.user.controls.firstName.untouched &&
                                  !writerSubmitted)
                              ">
                              Can not be blank
                            </div>
                          </fieldset>
                        </div>
                        <div class="col-md-4 col-sm-5 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="last-name">Last Name</label>
                            <input
                              id="last-name"
                              class="form-control"
                              formControlName="lastName"
                              placeholder="Last" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                writerForm.controls.user.controls.lastName.valid ||
                                (writerForm.controls.user.controls.lastName.pristine &&
                                  !writerSubmitted) ||
                                (writerForm.controls.user.controls.lastName.untouched &&
                                  !writerSubmitted)
                              ">
                              Can not be blank
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="email">Email</label>
                            <input
                              id="email"
                              class="form-control"
                              formControlName="email"
                              placeholder="email@example.com" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                writerForm.controls.user.controls.email.valid ||
                                (writerForm.controls.user.controls.email.pristine &&
                                  !writerSubmitted) ||
                                (writerForm.controls.user.controls.email.untouched &&
                                  !writerSubmitted)
                              ">
                              Email invalid
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8 col-sm-10 col-12">
                          <fieldset class="form-group" formGroupName="user">
                            <label for="pass"
                              >Create Password
                              <span class="small text-muted">(at least 8 characters)</span></label
                            >
                            <input
                              type="password"
                              id="pass"
                              class="form-control"
                              formControlName="password"
                              placeholder="password" />
                            <div
                              class="alert alert-danger"
                              [hidden]="
                                writerForm.controls.user.controls.password.valid ||
                                (writerForm.controls.user.controls.password.pristine &&
                                  !writerSubmitted) ||
                                (writerForm.controls.user.controls.password.untouched &&
                                  !writerSubmitted)
                              ">
                              Password invalid
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8 col-sm-10 col-12">
                          <div formGroupName="user">
                            <label for="tos-writer">
                              <input
                                id="tos-writer"
                                type="checkbox"
                                formControlName="termsOfService" />
                              I have read and agree to the
                              <a target="_blank" href="/pages/tos/writer"
                                >Verblio Terms of Service</a
                              >
                            </label>
                          </div>
                          <div
                            class="alert alert-danger"
                            [hidden]="
                              writerForm.controls.user.controls.termsOfService.valid ||
                              (writerForm.controls.user.controls.termsOfService.pristine &&
                                !writerSubmitted)
                            ">
                            You must accept the terms of service
                          </div>
                        </div>
                      </div>
                      <div class="row bottom-buffer">
                        <div class="col-md-8 col-sm-10 col-12">
                          <div class="text-right float-right">
                            <button
                              type="submit"
                              class="btn-lg hot-orange-button small-bottom-buffer block"
                              [disabled]="saving">
                              {{ writerWaitlistEnabled() ? 'Add Me to the Waitlist!' : 'Sign Up' }}
                            </button>
                            <div>or <a href="/d/users/sign_in">sign in</a></div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </ng-template>
                </div>
                <div class="col-md-10 offset-md-1 my-4" *ngIf="classification !== 'writer'">
                  <div class="carousel-wrapper">
                    <div class="carousel-inner">
                      <h6>All of our plans include</h6>
                      <hr />
                    </div>
                    <benefits-carousel></benefits-carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class NcRegistrationPage extends BaseComponent implements OnInit {
  classification: string = ''
  businessForm: FormGroup
  agencyForm: FormGroup
  writerForm: FormGroup
  private uiState: any
  private businessSubmitted: boolean = false
  private agencySubmitted: boolean = false
  private writerSubmitted: boolean = false
  private saving: boolean = false
  features: string[] = []

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private registrationActions: RegistrationActions,
    private customerActions: CustomerActions,
    private analyticsActions: AnalyticsActions,
    public featureQueries: FeatureQueries,
    private title: Title
  ) {
    super()
  }

  ngOnInit(): void {
    this.title.setTitle('Sign Up')

    this.businessForm = this.formBuilder.group({
      type: ['business', null],
      user: this.formBuilder.group({
        email: ['', [Validators.required, ValidationService.emailValidator]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(72)]],
      }),
      customer: this.formBuilder.group({
        businessName: ['', Validators.required],
      }),
    })

    this.agencyForm = this.formBuilder.group({
      type: ['agency', null],
      user: this.formBuilder.group({
        email: ['', [Validators.required, ValidationService.emailValidator]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(72)]],
      }),
      account: this.formBuilder.group({
        accountName: ['', Validators.required],
      }),
    })

    this.writerForm = this.formBuilder.group({
      type: ['writer', null],
      user: this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', [Validators.required, ValidationService.emailValidator]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(72)]],
        termsOfService: [false, ValidationService.checkBoxCheckedValidator],
      }),
    })

    const uiObs = NuclearObservable.from<Object>(userGetters.uiState, { toJS: true }).subscribe(
      (ui) => (this.uiState = ui)
    )
    this.observers.push(uiObs)

    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['email']) {
        const email = decodeURIComponent(queryParams['email'])
        if (email) {
          this.businessForm.patchValue({ user: { email } })
          this.agencyForm.patchValue({ user: { email } })
          this.writerForm.patchValue({ user: { email } })
        }
      }
      if (queryParams['usertype']) {
        this.classification = queryParams['usertype']
      }
    })
    this.featureQueries
      .getAppFeatures()
      .subscribe(
        ({
          loading,
          data,
          stale,
        }: {
          loading: boolean
          data: { features: Feature[] }
          stale: boolean
        }) => {
          this.features = (data && data.features) || []
        }
      )

    if (this.freeTenTopics()) {
      successToast(
        '<strong>10 Free Blog Topics Coupon Applied!</strong></br>Your 10 free blog topics will be applied to your account upon completing signing up.'
      )
    }
  }

  writerWaitlistEnabled(): boolean {
    return this.features && this.features.includes('writer_waitlist')
  }

  ngAfterViewInit(): void {
    if (!this.uiState || !this.uiState.registrationLanded) {
      this.analyticsActions.landedOnRegistration()
    }
  }

  updateClassification(newClassification: 'business' | 'agency' | 'writer'): void {
    this.classification = newClassification
    if (newClassification === 'business' || newClassification === 'agency') {
      this.analyticsActions.selectedRole(newClassification)
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          usertype: newClassification,
        },
        queryParamsHandling: 'merge',
      })
    }
    this.smoothScrollToBottom()
  }

  smoothScrollToBottom(): void {
    setTimeout(() => {
      const forms = document.getElementsByTagName('form')
      const form = forms && forms[0]
      if (form) scrollIntoViewIfNeeded(form, { easing: 'easeIn', duration: 220 })
    }, 0)
  }

  onSubmit(form: FormGroup): void {
    if (this.saving) return
    this.saving = true
    this.businessSubmitted = this.businessSubmitted || form === this.businessForm
    this.agencySubmitted = this.agencySubmitted || form === this.agencyForm
    this.writerSubmitted = this.writerSubmitted || form === this.writerForm
    if (!form.valid) {
      infoToast('Finish filling out the form to sign up')
      this.saving = false
    } else {
      this.analyticsActions.submittedLoginInfo()
      const augmentedFormValue = { ...form.value, ...this.urlParamsToSubmit() }
      this.registrationActions
        .registerCustomer(augmentedFormValue)
        .then(() => {
          this.continue(form.value.user.email, form.value.type)
        })
        .catch(() => {
          this.saving = false
        })
    }
  }

  continue(email: string, role: 'agency' | 'business' | 'writer'): void {
    const nav = () => {
      if (['agency', 'business'].includes(role)) {
        this.router.navigate(['/account', 'signup'])
      } else if (role === 'writer') {
        window.location.pathname = '/d/users/confirmation/new'
      } else {
        window.location.pathname = '/'
      }
    }
    nav()
  }

  private urlParamsToSubmit(): object {
    return { partnerKey: this.partnerKey(), freeTenTopics: this.freeTenTopics() }
  }

  private freeTenTopics(): boolean {
    const params = new URLSearchParams(window.location.search)
    return params.get('free_ten_topics') === 'true'
  }

  private partnerKey(): string {
    const params = new URLSearchParams(window.location.search)
    if (params.get('utm_partner')) {
      return params.get('utm_partner')

      // backup in case the link isn't configured to explicitly send partner_key
      // https://docs.partnerstack.com/discuss/5e70c0e90120750023ede4ca
    } else if (params.get('gspk')) {
      return atob(params.get('gspk'))
    }
  }
}
